import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';
import classList from 'flarum/common/utils/classList';
import sortWidgets from '../../common/utils/sortWidgets';
export default class TopWidgetSection extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.scrollEnd = Stream(false);
  }
  view() {
    if (!app.widgets.onWidgetPage()) return null;
    if (!app.widgets.get('top').length) return null;
    const isSmallScreen = ['phone', 'tablet'].includes(app.screen());
    return m("div", {
      className: "container"
    }, m("div", {
      className: classList({
        'FofWidgets-topWidgetSection FofWidgets-WidgetSection': true,
        'FofWidgets-WidgetSection--endScroll': isSmallScreen && this.scrollEnd()
      }),
      onscroll: e => {
        const target = e.target;
        const scrollEnd = isSmallScreen && target.offsetWidth + target.scrollLeft >= target.scrollWidth;

        // Scroll fires continuously; only redraw when the edge fade has to change.
        if (scrollEnd === this.scrollEnd()) {
          e.redraw = false;
          return;
        }
        this.scrollEnd(scrollEnd);
      }
    }, sortWidgets(app.widgets.get('top')).map(widget => widget.component.component({
      state: widget.state
    }))));
  }
}
flarum.reg.add('fof-forum-widgets-core', 'forum/components/TopWidgetSection', TopWidgetSection);